import React from 'react';
import { TimelineWrapperProps } from '../components/TimelineWrapper/TimelineWrapper';
import { ContentfulEntry } from '../components/ArticleRichText/ContentfulEntry';
import { ContentfulVideoTimeline } from '@jbhi-fi/apis/src/contentful/types';

export const contentfulVideoTimelineToTimelineWrapperProps = ({
  fields,
}: ContentfulVideoTimeline): TimelineWrapperProps => {
  return {
    heading: fields?.heading,
    children: (
      <>
        {fields?.videoTimestamps?.map((timestamp, i) => {
          const timestampEntry = new ContentfulEntry(timestamp);
          return <timestampEntry.OutputComponent {...timestampEntry.componentProps} key={`${i}-${timestamp.sys.id}`} />;
        })}
      </>
    ),
  };
};
